/**
 * @generated SignedSource<<4ae10498ce04d6649588ea32894eaf62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "LostPasswordMutationResponse",
    "kind": "LinkedField",
    "name": "lostPasswordMutation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LostPasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LostPasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9934972b44d765afc7bb3273213880d0",
    "id": null,
    "metadata": {},
    "name": "LostPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation LostPasswordMutation(\n  $email: String\n) {\n  lostPasswordMutation(email: $email) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "b694c0c00c88850e73f230d90af5aae4";

module.exports = node;
